import {Component, OnInit, HostListener, Input, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {OwnerService} from '../services/owner.service';
import {OwnersAdvanceSearch} from '../models/data-model';
import {SortPipeService} from '../../../pipes/sort-pipe.service';
import {GlobalDataService} from '../../housekeeping/services/global-data.service';
import {Angular2Csv} from 'angular2-csv/Angular2-csv';
import {ExportAvailability} from '../../../config';
import {DatePipe} from '@angular/common';
import * as moment from 'moment';
import {isNumeric} from "rxjs/util/isNumeric";

import * as jQuery from 'jquery';

@Component({
  selector: 'app-owner',
  templateUrl: '../views/owner.component.html',
  styleUrls: ['../css/owner.component.css'],
  providers: [DatePipe]
})
export class OwnerComponent implements OnInit {
  public userId: number;
  public offset: number = 0;
  public limit: number = 10;
  public showBack: boolean = false;
  public showNext: boolean = true;
  public showAdvance: boolean = false;
  public containsNumbers: boolean = false;
  public noData: boolean = false;
  public calledAdvanceSearchList: boolean = false;
  public advanceOffset: number = 0;
  public OwnerList: any = [];
  public headerOwnersList: any;
  public advanceOwnerSearchfields = new OwnersAdvanceSearch("", [], null, [], [], "", [], null, null, 0, 10, true, "", "", "", [], false);
  public finalExportData: any = [];
  public lastName: any = "";
  public showAdvanceLink: boolean = true;
  public enablePagination: boolean = true;
  public ownerExportStatus = true;
  public $j = jQuery.noConflict();
  // public sortColumn: string = '';
  public countryList: any = [];
  public dealerList: any = [];
  public ownershipStatus: any = [];
  public salesType: any = [];
  public showsubmission: boolean = false;
  public showsubmissionrange: boolean = false;
  public advanceSearchList: boolean = false;
  public normalSearch: boolean = false;
  public basicOffset: number = 0;
  public column: string = "";
  public sort: string = "ASC";
  public direction: boolean = false;
  public list: boolean = false;
  public normalSearchValues: any = {lastname: "", orderBy: "", sortBy: "", direction: false};
  public ownerListValues: any = {orderBy: "", sortBy: "", direction: ""};
  public EXPORT = ExportAvailability.export;
  public totalRecords = 0;
  public pageSize = 10;
  public p: number = parseInt(sessionStorage.getItem('ownerPageNo'));
  public RelativeDate = ["Last 7 Days", "Last 30 Days", "Last 60 Days"]
  //dropdown values
  public salesTypeSelected: any = [];
  public countrySelected: any = [];
  public ownershipStatusSelected: any = [];
  public dealerListSelected: any = [];
  public RDSelected: string = ""
  public regionSelected: any = []
  //Boolean
  public isSalesTypeAll: boolean = false;
  public isCountryAll: boolean = false;
  public isOwnershipStatusAll: boolean = false;
  public isDealerListAll: boolean = false;
  public isRegionAll: boolean = false

  //dropdown count
  public salesTypeCount: number = 0;
  public countryCount: number = 0;
  public ownershipStatusCount: number = 0;
  public dealerListCount: number = 0;
  public regionCount: number = 0;
  //count max values
  public SalesTypeIndex: any = [];
  public countryIndex: any = [];
  public ownershipStatusIndex: any = [];
  public dealerListIndex: any = [];
  public regionIndex: any = []
  //storing value to filter from criteria
  public filterSalesType: any = [];
  public filterCountry: any = [];
  public filterOwnershipStatus: any = [];
  public filterDealerList: any = [];
  public filterRegion: any = [];


  public pageExist: any;
  //For session storage

  public selectOrDeselect = {
    'isSalesTypeAll': false,
    'isCountryAll': false,
    'isOwnershipStatusAll': false,
    'isDealerListAll': false,
    'isRegionAll': false
  };

  //Settings for dropdowns
  public countrySettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'namecode',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public regionSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'codeDescription',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public salesTypeSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'desccode',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public ownershipStatusSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'desccode',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public dealerListSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'desccode',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public RDSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'desccode',
    itemsShowLimit: 1,
    allowSearchFilter: false
  };

  public showCriteria: any = [];


  fromPurchaseDate: Date;
  toPurchaseDate: Date;
//    storeFromPurchaseDate: string
//    storeToPurchaseDate: string


  @ViewChild('fromDateCal') datePicker1;
  @ViewChild('toDateCal') datePicker2;
  public datePickerClick = false;
  public regionList: any = [];

  constructor(public _router: Router, public _ownerService: OwnerService, public _sort: SortPipeService, public _dataService: GlobalDataService, private datePipe: DatePipe) {
  }

  ngOnInit() {
    if (sessionStorage.getItem("pageLimit") !== null) {
      this.limit = Number(sessionStorage.getItem("pageLimit"));
      this.pageSize = Number(sessionStorage.getItem("pageLimit"))
    }

    if (!this.EXPORT) {
      document.getElementById("ownersExport").classList.add('hidden');
    }

    //this.userId = Number(localStorage.getItem('userId'));
    this.userId = Number(sessionStorage.getItem('userId'));
    this.prepareOwnerTable();
    const path = this._dataService.getPreviousUrl();
    if (!(path.includes('/owners/detail') || path.includes('/owners/edit') || path.includes('/owners/ownerchage'))) {
      this.getOwnerList();
    }
    if (path.includes('/owners/detail') || path.includes('/owners/edit') || path.includes('/owners/ownerchage')) {

      if (sessionStorage.getItem("normalSearch") !== null) {
        this.basicOffset = Number(sessionStorage.getItem("normalSearch"));
        if (this.basicOffset > 0) {
          this.showBack = true;
        }
        this.normalSearchValues = JSON.parse(sessionStorage.getItem("normalSearchValues"));
        if (this.normalSearchValues != null) {
          this.lastName = this.normalSearchValues.lastname;
          this.column = this.normalSearchValues.orderBy;
          this.sort = this.normalSearchValues.sortBy;
          this.direction = this.normalSearchValues.direction;
        }
        this.basicSearch();
      } else if (sessionStorage.getItem("advanceSearch") !== null) {

        this.advanceOffset = Number(sessionStorage.getItem("advanceSearch"));
        this.direction = JSON.parse(sessionStorage.getItem("advanceSearchDirection"));
        if (this.advanceOffset > 0) {
          this.showBack = true;
        }
        this.selectOrDeselect = JSON.parse(sessionStorage.getItem("selectOrDeselect"));
        //To prevent select all and to send empty array
        this.isSalesTypeAll = this.selectOrDeselect.isSalesTypeAll;
        this.isCountryAll = this.selectOrDeselect.isCountryAll;
        this.isOwnershipStatusAll = this.selectOrDeselect.isOwnershipStatusAll;
        this.isDealerListAll = this.selectOrDeselect.isDealerListAll;
        this.isRegionAll = this.selectOrDeselect.isRegionAll;
        //assiging session values to dropdowns
        this.advanceOwnerSearchfields = JSON.parse(sessionStorage.getItem("advancesearchfields"));
        this.salesTypeSelected = this.advanceOwnerSearchfields.salesTypeIds;
        this.countrySelected = this.advanceOwnerSearchfields.countryIds;
        this.ownershipStatusSelected = this.advanceOwnerSearchfields.ownershipStatusList;
        this.dealerListSelected = this.advanceOwnerSearchfields.dealerIds;

        this.advanceOwnerSearchfields = JSON.parse(sessionStorage.getItem("advancesearchfields"));

        if (this.advanceOwnerSearchfields.fromPurchaseDate != null && this.advanceOwnerSearchfields.fromPurchaseDate != "") {
          this.fromPurchaseDate = new Date(this.advanceOwnerSearchfields.fromPurchaseDate);
          this.onSelectFromPurchase(this.fromPurchaseDate)
        }
        if (this.advanceOwnerSearchfields.toPruchaseDate != null && this.advanceOwnerSearchfields.toPruchaseDate != "") {
          //  this.showsubmission = false;
          //  this.showsubmissionrange = true;
          this.toPurchaseDate = new Date(this.advanceOwnerSearchfields.toPruchaseDate);
          this.onSelectToPurchase(this.toPurchaseDate)

        }

        this.lastName = this.advanceOwnerSearchfields.lastName;
        this.sort = this.advanceOwnerSearchfields.sortBy;
        this.column = this.advanceOwnerSearchfields.orderBy;
        this.advanceSearch();
      } else if (sessionStorage.getItem("list") !== null) {
        this.offset = Number(sessionStorage.getItem("list"));
        if (this.offset > 0) {
          this.showBack = true;
        }
        this.ownerListValues = JSON.parse(sessionStorage.getItem("ownerListValues"));
        if (this.ownerListValues != null) {
          this.sort = this.ownerListValues.sortBy;
          this.column = this.ownerListValues.orderBy;
          this.direction = this.ownerListValues.direction;
        }
        this.getOwnerList();
      } else {
        this.getOwnerList();
      }
    }
    this.getCountryList();
    this.getOwnershipStatus();
    this.getDealerList();
    this.getSalesType();
    this.getRegionList();
    sessionStorage.setItem("isVin", "false");
  }

  /**
   * @author Nagendra
   * @description To get row and label fields data
   */
  prepareOwnerTable() {
    this.headerOwnersList = [];
    this._ownerService.getOwnerPreference(this.userId, (result) => {
      if (result.length != 0) {
        result.sort((a: any, b: any) => {
          if (a.sequence < b.sequence) {
            return -1;
          } else if (a.sequence > b.sequence) {
            return 1;
          } else {
            return 0;
          }
        });
        this.headerOwnersList = result
      }
      //If no preference set go to default preferences
      else {
        this.getDefaultPreferences();
      }

    })
  }

  /**
   * @author Nagendra
   * @description Get default user preference
   * @returns All settings preference
   */
  getDefaultPreferences() {
    this._ownerService.getviewSettings(result => {
      if (result.length != 0) {
        result.sort((a: any, b: any) => {
          if (a.sequence < b.sequence) {
            return -1;
          } else if (a.sequence > b.sequence) {
            return 1;
          } else {
            return 0;
          }
        });
        result.forEach(setting => {
          if (setting.isDefult == true) {
            this.headerOwnersList.push({setting});
          }
        })
      }
    });
  }

  /**
   * @author Nagendra
   * @description Preparing Owner List data
   */
  getOwnerList() {
    this.OwnerList = [];
    this.list = true;
    this.advanceSearchList = false;
    this.normalSearch = false;
    this.basicOffset = 0;
    this.advanceOffset = 0;
    this._ownerService.getOwnersList(this.userId, this.offset, this.limit, this.column, this.sort, (result) => {

      this.OwnerList = result.beans;
//          console.log("pagecount"+result.pageCount)
      if (this.offset == 0) {
        sessionStorage.removeItem("totalCount");
        this.totalRecords = result.pageCount;
        sessionStorage.setItem("totalCount", result.pageCount);
      }

      if (this.OwnerList == '') {
        this.showNext = false;
        this.noData = true;
      } else if (this.OwnerList.length < 10) {
        this.showNext = false;
        this.noData = false;
      } else if (this.OwnerList.length == 10) {
        this.showNext = true;
        this.noData = false;
      } else if (this.OwnerList.length > 10) {
        this.showNext = true;
        this.noData = false;
      } else {
        this.showNext = false;
        this.showBack = false;
        this.noData = true;
      }
      if (sessionStorage.getItem('totalCount') != null) {
        this.totalRecords = Number(sessionStorage.getItem("totalCount"));
      }
      if (this.OwnerList.length == 0) {
        this.noData = false;
      }

    });
  }

  /**
   * @author Nagendra
   * @description Get Previous Page
   */

  GoBack() {
    this.offset -= 10;
    if (this.offset == 0) {
      this.showBack = false;
      this.noData = false;
    }
    if (this.advanceSearchList == true) {
      this.offset = 0;
      this.basicOffset = 0;
      this.advanceOffset -= 10;
      if (this.advanceOffset == 0) {
        this.showBack = false;
        this.noData = false;
      } else if (this.advanceOffset > 0) {
        this.showNext = true;
      }
      this.advanceSearch();
    } else if (this.normalSearch == true) {
      this.offset = 0;
      this.advanceOffset = 0;
      this.basicOffset -= 10;
      if (this.basicOffset == 0) {
        this.showBack = false;
        this.noData = false;
      }
      if (this.basicOffset > 0) {
        this.showNext = true;
      }
      this.basicSearch();
    } else {
      this.getOwnerList();
    }

  }

  /**
   * @author Nagendra
   * @description Get Next Page
   */
  nextPage() {
    this.showBack = false;
    this.offset += 10;
    if (this.offset > 0) {
      this.showBack = true;
    }
    if (this.advanceSearchList == true) {
      this.offset = 0;
      this.basicOffset = 0;
      this.advanceOffset += 10;
      if (this.advanceOffset > 0) {
        this.showBack = true;
      }
      this.advanceSearch();
    } else if (this.normalSearch == true) {
      this.offset = 0;
      this.advanceOffset = 0;
      this.basicOffset += 10;
      if (this.basicOffset > 0) {
        this.showBack = true;
      }
      this.basicSearch();
    } else {
      this.getOwnerList();
    }
  }

  /**
   * @author Nagendra
   * @description show Owner advance search page
   */
  showadvanceSearch(value) {
    this.showAdvance = value;
    if (this.showAdvance) {
      this.showBack = false;
      this.showAdvanceLink = false
    } else {
      this.offset = 0;
      this.basicOffset = 0;
      this.advanceOffset = 0;
      this.lastName = "";
      this.showsubmission = false;
      this.showsubmissionrange = false;
      this.showAdvanceLink = true;
      this.showCriteria = [];
      this.getOwnerList();
    }
  }

  /**
   * @author Nagendra
   * @description Search by lastName
   */
  basicSearch() {
    this.salesTypeSelected = [];
    this.countrySelected = [];
    this.ownershipStatusSelected = [];
    this.dealerListSelected = [];
    this.regionSelected = [];
    this.advanceOwnerSearchfields = new OwnersAdvanceSearch("", [], null, [], [], "", [], null, null, 0, 10, true, "", "", "", [], false);
    this.showCriteria = [];
    this.OwnerList = [];
    this.list = false;
    this.normalSearch = true;
    this.advanceSearchList = false;
    this.offset = 0;
    this.advanceOffset = 0;
    //To enable/disable Export functionality
    this.ownerExportStatus = false;
    if (!this.ownerExportStatus) {

    }
    if (this.basicOffset == 0) {
      this.showBack = false;
    }
    this._ownerService.getOwnerSearch(this.userId, this.lastName, this.basicOffset, this.limit, this.column, this.sort, (result) => {
      this.OwnerList = result.beans;
      var count = 0;
      for (let i = 0; i < this.OwnerList.length; i++) {
        if (this.lastName == this.OwnerList[i].vin) {
          count++;
        }
      }
      if (count == this.OwnerList.length) {
        this.OwnerList.sort((a, b) => (a.ownershipStatus > b.ownershipStatus) ? 1 : ((b.ownershipStatus > a.ownershipStatus) ? -1 : 0));

        sessionStorage.setItem("isVin", "true");
      } else {
        sessionStorage.setItem("isVin", "false");
      }
      if (this.basicOffset == 0) {
        sessionStorage.removeItem("totalCount");
        this.totalRecords = result.pageCount;
        sessionStorage.setItem("totalCount", result.pageCount);
      }

      if (this.OwnerList == '') {
        this.showNext = false;
        this.noData = true;
      } else if (this.OwnerList.length < 10) {
        this.showNext = false;
        this.noData = false;
      } else if (this.OwnerList.length == 10) {
        this.showNext = true;
        this.noData = false;
      } else if (this.OwnerList.length > 10) {
        this.showNext = true;
        this.noData = false;
      } else {
        this.showNext = false;
        this.showBack = false;
        this.noData = true;
      }
      if (sessionStorage.getItem('totalCount') != null) {
        this.totalRecords = Number(sessionStorage.getItem("totalCount"));
      }
    });
  }


  compare(a, b) {
    if (a.ownershipStatus < b.ownershipStatus) {
      return -1;
    }
    if (a.ownershipStatus > b.ownershipStatus) {
      return 1;
    }
    return 0;
  }

  /**
   * @author Nagendra
   * @description Advance Search
   */
  advanceSearch() {

    /**
     * @author Nagendra
     * @description Used to push values to showCriteria based on value given for advance fields
     * @uses To show criteria after advance search
     * @created Date 24-10-2018
     * @modified Date 26-10-2018
     */
    this.showCriteria = [];

    //resetting count values
    this.salesTypeCount = 0;
    this.countryCount = 0;
    this.ownershipStatusCount = 0;
    this.dealerListCount = 0;
    this.regionCount = 0;
    //resetting filter values
    this.SalesTypeIndex = [];
    this.countryIndex = [];
    this.ownershipStatusIndex = [];
    this.dealerListIndex = [];
    this.regionIndex = [];
    //storing value to filter from criteria
    this.filterSalesType = [];
    this.filterCountry = [];
    this.filterOwnershipStatus = [];
    this.filterDealerList = [];
    this.filterRegion = [];
    //To enable/disable Export functionality
    this.ownerExportStatus = false;
    if (!this.ownerExportStatus) {

    }
    if (this.lastName.trim() != "") {
      this.showCriteria.push({
        label: 'LastName',
        value: this.lastName
      })
    }
    if (this.advanceOwnerSearchfields.firstName.trim() != "") {
      this.showCriteria.push({
        label: 'firstName',
        value: this.advanceOwnerSearchfields.firstName
      })
    }
    if (this.RDSelected != "" && this.RDSelected != null) {
      this.advanceOwnerSearchfields.fromPurchaseDate = ""
      this.advanceOwnerSearchfields.toPruchaseDate = ""
      this.fromPurchaseDate = null
      this.toPurchaseDate = null
      this.showCriteria.push({
        label: 'Relative Purchase Date',
        value: this.RDSelected
      })
    }
    if (this.advanceOwnerSearchfields.vin.trim() != "") {
      this.showCriteria.push({
        label: 'VIN',
        value: this.advanceOwnerSearchfields.vin
      })

      sessionStorage.setItem("isVin", "true");
    } else {
      sessionStorage.setItem("isVin", "false");
    }
    if (this.advanceOwnerSearchfields.fromPurchaseDate != null && this.advanceOwnerSearchfields.fromPurchaseDate != "") {
      //as we are using same variable fromPurchaseDate for both purchase and from date
      if (this.showsubmissionrange == false) {
        this.showCriteria.push({
          label: 'Purchase Date',
          value: this.advanceOwnerSearchfields.fromPurchaseDate
        })
      }

    }
    if (this.RDSelected == "" || this.RDSelected == null) {
      if (this.advanceOwnerSearchfields.fromPurchaseDate != null && this.advanceOwnerSearchfields.fromPurchaseDate != "") {
        if (this.showsubmissionrange == true) {
          this.showCriteria.push({
            label: 'From Date',
            value: this.advanceOwnerSearchfields.fromPurchaseDate
          })
        }
      }
      if (this.advanceOwnerSearchfields.toPruchaseDate != null && this.advanceOwnerSearchfields.toPruchaseDate != "") {
        this.showCriteria.push({
          label: 'To Date',
          value: this.advanceOwnerSearchfields.toPruchaseDate
        })
      }
    }
    //To show All value for label if select all is used
    if (this.isSalesTypeAll == true) {
      this.showCriteria.push({
        id: 'saleTypeAll',
        label: 'Sale Type',
        value: 'All'
      })
    }
    if (this.isCountryAll == true) {
      this.showCriteria.push({
        id: 'countryCodeAll',
        label: 'Country Code',
        value: 'All'
      })
    }
    if (this.isOwnershipStatusAll == true) {
      this.showCriteria.push({
        id: 'ownershipStatusAll',
        label: 'Ownership Status',
        value: 'All'
      })
    }
    if (this.isDealerListAll == true) {
      this.showCriteria.push({
        id: 'dealerNameAll',
        label: 'Dealer Name',
        value: 'All'
      })
    }
    if (this.isRegionAll == true) {
      this.showCriteria.push({
        id: 'regionAll',
        label: 'Region',
        value: 'All'
      })
    }

    this.advanceOwnerSearchfields.countryIds = [];
    this.advanceOwnerSearchfields.salesTypeIds = [];
    this.advanceOwnerSearchfields.ownershipStatusList = [];
    this.advanceOwnerSearchfields.dealerIds = [];
    this.advanceOwnerSearchfields.regionIds = [];
    /**
     * @author Nagendra
     * @description dropdowns value are checked,if select all/unselect all used then boolean value for that will be true and it sends empty array
     */
    if (Object.keys(this.salesTypeSelected).length > 0 && this.salesTypeSelected != undefined && this.isSalesTypeAll != true) {
      Object.keys(this.salesTypeSelected).map(key => (
        this.advanceOwnerSearchfields.salesTypeIds.push(
          this.salesTypeSelected[key]['id']),
          this.showCriteria.push({
            id: this.salesTypeSelected[key]['id'],
            label: 'Sale Type',
            value: this.salesTypeSelected[key]['desccode']
          })
      ));
    }
    if (this.RDSelected != "" && this.RDSelected != undefined) {
      var FromDate = new Date()
      var toDate = new Date()
      if (this.RDSelected == "Last 7 Days") {
        FromDate.setDate(FromDate.getDate() - 7);
        this.advanceOwnerSearchfields.toPruchaseDate = this.datePipe.transform(toDate, "yyyy-MM-dd");
        this.advanceOwnerSearchfields.fromPurchaseDate = this.datePipe.transform(FromDate, "yyyy-MM-dd");
      }
      if (this.RDSelected == "Last 30 Days") {
        FromDate.setDate(FromDate.getDate() - 30);
        this.advanceOwnerSearchfields.toPruchaseDate = this.datePipe.transform(toDate, "yyyy-MM-dd");
        this.advanceOwnerSearchfields.fromPurchaseDate = this.datePipe.transform(FromDate, "yyyy-MM-dd");
      }
      if (this.RDSelected == "Last 60 Days") {
        FromDate.setDate(FromDate.getDate() - 60);
        this.advanceOwnerSearchfields.toPruchaseDate = this.datePipe.transform(toDate, "yyyy-MM-dd");
        this.advanceOwnerSearchfields.fromPurchaseDate = this.datePipe.transform(FromDate, "yyyy-MM-dd");
      }
    }

    if (Object.keys(this.countrySelected).length > 0 && this.countrySelected != undefined && this.isCountryAll != true) {
      Object.keys(this.countrySelected).map(key => (
        this.advanceOwnerSearchfields.countryIds.push(
          this.countrySelected[key]['id']),
          this.showCriteria.push({
            id: this.countrySelected[key]['id'],
            label: 'Country Code',
            value: this.countrySelected[key]['namecode']
          })
      ));
    }
    if (Object.keys(this.ownershipStatusSelected).length > 0 && this.ownershipStatusSelected != undefined && this.isOwnershipStatusAll != true) {
      Object.keys(this.ownershipStatusSelected).map(key => (
        this.advanceOwnerSearchfields.ownershipStatusList.push(
          this.ownershipStatusSelected[key]['id']),
          this.showCriteria.push({
            id: this.ownershipStatusSelected[key]['id'],
            label: 'Ownership Status',
            value: this.ownershipStatusSelected[key]['desccode']
          })
      ));

    }
    if (Object.keys(this.dealerListSelected).length > 0 && this.dealerListSelected != undefined && this.isDealerListAll != true) {
      Object.keys(this.dealerListSelected).map(key => (
        this.advanceOwnerSearchfields.dealerIds.push(
          this.dealerListSelected[key]['id']),
          this.showCriteria.push({
            id: this.dealerListSelected[key]['id'],
            label: 'Dealer Name',
            value: this.dealerListSelected[key]['desccode']
          })
      ));
    }
    if (Object.keys(this.regionSelected).length > 0 && this.regionSelected != undefined && this.isRegionAll != true) {
      Object.keys(this.regionSelected).map(key => (
        this.advanceOwnerSearchfields.regionIds.push(
          this.regionSelected[key]['id']),
          this.showCriteria.push({
            id: this.regionSelected[key]['id'],
            label: 'Region',
            value: this.regionSelected[key]['codeDescription']
          })
      ));
    }

    this.OwnerList = [];
    this.list = false;
    this.normalSearch = false;
    this.advanceSearchList = true;
    this.offset = 0;
    this.basicOffset = 0;
    if (this.advanceOffset == 0) {
      this.showBack = false;
    }
    this.showAdvanceLink = true;
    this.advanceOwnerSearchfields.userId = this.userId;
    this.advanceOwnerSearchfields.lastName = this.lastName;
    this.advanceOwnerSearchfields.offset = this.advanceOffset;
    this.advanceOwnerSearchfields.orderBy = this.column;
    this.advanceOwnerSearchfields.sortBy = this.sort;
    this.advanceOwnerSearchfields.isPagination = this.enablePagination;

    this.advanceOwnerSearchfields.pageLimit = this.limit;
    this.noData = false;


//counting dropdown values
    this.showCriteria.map((obj) => {
      if (obj.label == "Sale Type") {
        this.salesTypeCount++
      }
      if (obj.label == "Country Code") {
        this.countryCount++
      }
      if (obj.label == "Ownership Status") {
        this.ownershipStatusCount++
      }
      if (obj.label == "Dealer Name") {
        this.dealerListCount++
      }
      if (obj.label == "Region") {
        this.regionCount++
      }
    });

    //Checking index of particular label values and pushing

    if (this.salesTypeCount > 3 && this.isSalesTypeAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Sale Type") {
          this.SalesTypeIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }
    if (this.countryCount > 3 && this.isCountryAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Country Code") {
          this.countryIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }
    if (this.ownershipStatusCount > 3 && this.isOwnershipStatusAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Ownership Status") {
          this.ownershipStatusIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }
    if (this.dealerListCount > 3 && this.isDealerListAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Dealer Name") {
          this.dealerListIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }
    if (this.regionCount > 3 && this.isRegionAll != true) {
      this.showCriteria.map((obj) => {
        if (obj.label == "Region") {
          this.regionIndex.push(this.showCriteria.indexOf(obj))
        }
      })
    }


    //Removing values from Criteria and appending one value with count
    if (Object.keys(this.SalesTypeIndex).length > 3 && this.isSalesTypeAll != true) {
      this.SalesTypeIndex.map(index => {
        this.filterSalesType.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxSaleType',
        label: 'Sale Type',
        value: this.salesTypeSelected[0].desccode + " + " + (this.salesTypeCount - 1)
      })
    }

    if (Object.keys(this.countryIndex).length > 3 && this.isCountryAll != true) {
      this.countryIndex.map(index => {
        this.filterCountry.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxCountry',
        label: 'Country Code',
        value: this.countrySelected[0].namecode + " + " + (this.countryCount - 1)
      })
    }

    if (Object.keys(this.ownershipStatusIndex).length > 3 && this.isOwnershipStatusAll != true) {
      this.ownershipStatusIndex.map(index => {
        this.filterOwnershipStatus.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxOwnershipStatus',
        label: 'Ownership Status',
        value: this.ownershipStatusSelected[0].desccode + " + " + (this.ownershipStatusCount - 1)
      })
    }

    if (Object.keys(this.dealerListIndex).length > 3 && this.isDealerListAll != true) {
      this.dealerListIndex.map(index => {
        this.filterDealerList.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxDealer',
        label: 'Dealer Name',
        value: this.dealerListSelected[0].desccode + " + " + (this.dealerListCount - 1)
      })
    }
    if (Object.keys(this.regionIndex).length > 3 && this.isRegionAll != true) {
      this.regionIndex.map(index => {
        this.filterRegion.push(this.showCriteria[index])
      });
      this.showCriteria.push({
        id: 'maxRegion',
        label: 'Region',
        value: this.regionSelected[0].codeDescription + " + " + (this.regionCount - 1)
      })
    }

    //Filtering values
    let filtered = this.showCriteria.filter(item => !this.filterSalesType.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterCountry.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterOwnershipStatus.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterDealerList.includes(item));
    this.showCriteria = filtered;

    filtered = this.showCriteria.filter(item => !this.filterRegion.includes(item));
    this.showCriteria = filtered;

    this._ownerService.getSearchOwnerList(this.advanceOwnerSearchfields, (result) => {
      this.showAdvance = false;
      this.OwnerList = result.beans;
      if (this.advanceOwnerSearchfields.vin.trim() != "") {
        this.OwnerList.sort((a, b) => (a.ownershipStatus > b.ownershipStatus) ? 1 : ((b.ownershipStatus > a.ownershipStatus) ? -1 : 0));
      }
      if (this.advanceOffset == 0) {
        sessionStorage.removeItem("totalCount");
        this.totalRecords = result.pageCount;
        sessionStorage.setItem("totalCount", result.pageCount);
      }

      if (this.OwnerList == '') {
        this.showNext = false;
        this.noData = true;
      } else if (this.OwnerList.length < 10) {
        this.showNext = false;
        this.noData = false;
      } else if (this.OwnerList.length == 10) {
        this.showNext = true;
        this.noData = false;
      } else if (this.OwnerList.length > 10) {
        this.showNext = true;
        this.noData = false;
      } else {
        this.showNext = false;
        this.showBack = false;
        this.noData = true;
      }

      if (sessionStorage.getItem('totalCount') != null) {
        this.totalRecords = Number(sessionStorage.getItem("totalCount"));
      }
    })
  }

  /**
   * @author Nagendra
   * @description Show DateRange on click
   */
  showdaterange(val) {
    if (val) {
      this.showsubmission = true;
      this.showsubmissionrange = false;
      this.advanceOwnerSearchfields.fromPurchaseDate = "";
      this.fromPurchaseDate = null
    } else {
      this.showsubmission = false;
      this.showsubmissionrange = true;
      this.fromPurchaseDate = null;
      this.toPurchaseDate = null;
      this.advanceOwnerSearchfields.fromPurchaseDate = "";
      this.advanceOwnerSearchfields.toPruchaseDate = "";
    }
  }

  /**
   * @author Pradeep
   * @description redirect to owner detail page
   */
  viewOwnerDetails(ownerId, vin, vehicleId) {
    sessionStorage.setItem("pageNo", String(this.p));
    if (this.normalSearch == true) {
      this.normalSearchValues.lastname = this.lastName;
      this.normalSearchValues.sortBy = this.sort;
      this.normalSearchValues.orderBy = this.column;
      this.normalSearchValues.direction = this.direction;
      sessionStorage.removeItem("advanceSearch");
      sessionStorage.removeItem("advanceSearchDirection");
      sessionStorage.removeItem("advancesearchfields");
      sessionStorage.removeItem("list");
      sessionStorage.removeItem("ownerListValues");
      sessionStorage.removeItem("selectOrDeselect");
      sessionStorage.setItem("normalSearch", this.basicOffset.toString());
      sessionStorage.setItem("normalSearchValues", JSON.stringify(this.normalSearchValues));

    } else if (this.advanceSearchList == true) {
      sessionStorage.removeItem("normalSearch");
      sessionStorage.removeItem("normalSearchValues");
      sessionStorage.removeItem("list");
      sessionStorage.removeItem("ownerListValues");
      sessionStorage.setItem("advanceSearch", this.advanceOffset.toString());
      sessionStorage.setItem("advanceSearchDirection", this.direction.toString());
      /**
       * @author Nagendra
       * @description Assiging local values of dropdown to session storage value (advancesearchfields)
       */
      this.advanceOwnerSearchfields.salesTypeIds = this.salesTypeSelected;
      this.advanceOwnerSearchfields.countryIds = this.countrySelected;
      this.advanceOwnerSearchfields.ownershipStatusList = this.ownershipStatusSelected;
      this.advanceOwnerSearchfields.dealerIds = this.dealerListSelected;

      if (this.advanceOwnerSearchfields.fromPurchaseDate != null && this.advanceOwnerSearchfields.fromPurchaseDate != "" && this.fromPurchaseDate != null) {
        this.advanceOwnerSearchfields.fromPurchaseDate = this.fromPurchaseDate.toDateString();
      }
      if (this.advanceOwnerSearchfields.toPruchaseDate != null && this.advanceOwnerSearchfields.toPruchaseDate != "" && this.toPurchaseDate != null) {
        this.advanceOwnerSearchfields.toPruchaseDate = this.toPurchaseDate.toDateString();
      }


      //Used for select all/de-select all boolean values
      this.selectOrDeselect = {
        'isSalesTypeAll': this.isSalesTypeAll,
        'isCountryAll': this.isCountryAll,
        'isOwnershipStatusAll': this.isOwnershipStatusAll,
        'isDealerListAll': this.isDealerListAll,
        'isRegionAll': this.isRegionAll
      };
      sessionStorage.setItem("selectOrDeselect", JSON.stringify(this.selectOrDeselect));
      sessionStorage.setItem("advancesearchfields", JSON.stringify(this.advanceOwnerSearchfields));
    } else {
      this.ownerListValues.sortBy = this.sort;
      this.ownerListValues.orderBy = this.column;
      this.ownerListValues.direction = this.direction;
      sessionStorage.removeItem("advanceSearch");
      sessionStorage.removeItem("advanceSearchDirection");
      sessionStorage.removeItem("advancesearchfields");
      sessionStorage.removeItem("normalSearch");
      sessionStorage.removeItem("normalSearchValues");
      sessionStorage.removeItem("selectOrDeselect");
      sessionStorage.setItem("list", this.offset.toString());
      sessionStorage.setItem("ownerListValues", JSON.stringify(this.ownerListValues));
    }
    this._router.navigate(['owners/detail/' + ownerId + '/' + vin + '/' + vehicleId])
  }

  /**
   * @author Nagendra
   * @description Get country List
   */
  getCountryList() {
    this._ownerService.getOwnerCountryList(result => {
      result.forEach(obj => {
        this.countryList.push({
          id: obj.id,
          name: obj.name,
          code: obj.code,
          namecode: obj.code + '(' + obj.name + ')'
        })
      })
    })
  }

  /**
   * @author Nagendra
   * @description Get Dealer List
   */
  getDealerList() {
    this._ownerService.getOwnerDealerList(this.userId, result => {
      result.forEach(obj => {
        this.dealerList.push({
          id: obj.id,
          name: obj.name,
          globalCode: obj.globalCode,
          desccode: obj.name + '(' + obj.globalCode + ')'
        })
      })
    })
  }

  /**
   * @author Nagendra
   * @description Get Sales Type
   */
  getSalesType() {
    this._ownerService.getOwnerSalesType(result => {
      result.forEach(obj => {
        this.salesType.push({
          id: obj.id,
          description: obj.description,
          code: obj.code,
          desccode: obj.description + '(' + obj.code + ')'
        })

      })

    })
  }

  /**
   * @author Nagendra
   * @description Get Ownership status
   */
  getOwnershipStatus() {
    this._ownerService.getOwnershipStatus(result => {
      result.forEach(obj => {
        this.ownershipStatus.push({
          id: obj.transactionType,
          desccode: obj.ownershipStatus
        })

      })
    })
  }

  /**
   * @author Nagendra
   * @description To hide Advance Search on click outside of div
   */
//    @HostListener('document:click', ['$event']) clickedOutside($event) {
//        if (this.showAdvance == true) {
//            this.showAdvance = false;
//            this.showAdvanceLink = true
//        }
//    }
//
//    clickedInside($event: Event) {
//        $event.preventDefault();    // prevent default event of that browser
//        $event.stopPropagation();  // that will stop propagation on lower layers
//    }

  @HostListener('document:click', ['$event'])
  clickedOutside($event) {
    const thisObj = this;
    if (!thisObj.showAdvanceLink && jQuery($event.target).closest('div.search-boxdiv').length == 0 && jQuery($event.target).closest('div.adv-topdiv').length == 0 && (jQuery($event.target).closest('a.adv-search').length == 0)) {
      if (!thisObj.datePickerClick) {
        this.showAdvance = false;
        this.showAdvanceLink = true
        //thisObj.searchFormObj.reset();
      } else {
        thisObj.datePickerClick = false;
      }
    }
  }

  /**
   * @author Nagendra
   * @description Used to convert into Date Format
   */
//    convertToDate(date) {
//        if (date != null && date != "") {
//            var dateFormat = moment(date).format("YYYY-MM-DD");
//            return dateFormat;
//        }
//        else {
//            return null;
//        }
//    }
  checkIfContainsNumbers(n) {
    if (this.isNumber(n)) {
      this.containsNumbers = true
    } else {
      this.containsNumbers = false
    }
  }

  setOffset() {
    if (this.fromPurchaseDate != null) {
      this.advanceOwnerSearchfields.fromPurchaseDate = this.datePipe.transform(this.fromPurchaseDate.toString(), "yyyy-MM-dd");
    }
    if (this.toPurchaseDate != null) {
      this.advanceOwnerSearchfields.toPruchaseDate = this.datePipe.transform(this.toPurchaseDate.toString(), "yyyy-MM-dd")
    }

    this.basicOffset = 0;
    this.advanceOffset = 0;
  }

  isNumber(n) {
    return /\d/.test(n);
  }

  sortBy(i) {
    this.column = this.headerOwnersList[i].setting.property.slice(6);
    this.direction = !this.direction;
    if (this.direction) {
      this.sort = "ASC";
    } else {
      this.sort = "DESC";
    }
    if (this.list) {
      this.offset = 0;
      this.showBack = false;
      this.showNext = false;
      this.noData = false;
      this.getOwnerList();
    } else if (this.normalSearch) {
      this.showBack = false;
      this.showNext = false;
      this.noData = false;
      this.basicOffset = 0;
      this.basicSearch();
    } else {
      this.showBack = false;
      this.showNext = false;
      this.noData = false;
      this.advanceOffset = 0;
      this.advanceSearch();
    }
  }

  /*
  * @author Ciocan Vlad
  * @uses For pagination
  * @date 22-10-2018
  * @modified date 22-10-2018
  */
  pageChanged(event) {
    if (this.pageExist != event) {
      sessionStorage.setItem('ownerPageNo', event);
      this.pageExist = event;
      if (this.advanceSearchList == true) {
        this.offset = 0;
        this.basicOffset = 0;
        if (event >= 1) {
          this.advanceOffset = (this.pageSize * (event - 1))
          // console.log("****************advanceOffset******************" + this.advanceOffset);
        } else {
          this.advanceOffset = 0
        }
        this.advanceSearch();
      } else if (this.normalSearch == true) {
        this.offset = 0;
        this.advanceOffset = 0;
        if (event >= 1) {
          this.basicOffset = (this.pageSize * (event - 1))
          //   console.log("****************basicOffset******************" + this.basicOffset);
        } else {
          this.basicOffset = 0
        }
        this.basicSearch();
      } else {
        if (event >= 1) {
          this.offset = (this.pageSize * (event - 1))
          //    console.log("****************normal******************" + this.offset);
        } else {
          this.offset = 0
        }
        this.getOwnerList();
      }
    }
  }

  /*
* @author Ciocan Vlad
* @uses To change page size for list
* @date 22-10-2018
* @modified date 22-10-2018
*/

  changepageSize() {
    //      console.log("***1111111****************************************" + this.p)
    this.limit = this.pageSize;
    if (sessionStorage.getItem("pageLimit") !== null) {
      sessionStorage.removeItem("pageLimit")
    }
    sessionStorage.setItem("pageLimit", this.limit.toString());
    this._ownerService.updatePageLimit(this.userId, this.limit, result => {
//        console.log("result"+result)
    })
    if (this.advanceSearchList == true) {
      this.advanceSearch();
    } else if (this.normalSearch == true) {
      this.basicSearch();
    } else {
      this.getOwnerList();
    }
  }

  /**
   * @author Nagendra
   * @description SelectAll and DeSelectAll from dropdowns
   * @uses To make empty array if select all or unselect all
   * @date 24-10-2018
   * @modified date 29-10-2018
   */
  onCountrySelectAll(value) {
    this.isCountryAll = true
  }

  onCountryDeSelectAll(value) {
    this.isCountryAll = false
  }

  onSalesTypeSelectAll(value) {
    this.isSalesTypeAll = true
  }

  onSalesTypeDeSelectAll(value) {
    this.isSalesTypeAll = false
  }

  onOwnershipStatusSelectAll(value) {
    this.isOwnershipStatusAll = true
  }

  onOwnershipStatusDeSelectAll(value) {
    this.isOwnershipStatusAll = false
  }

  onDealerListSelectAll(value) {
    this.isDealerListAll = true
  }

  onDealerListDeSelectAll(value) {
    this.isDealerListAll = false
  }

  onRegionSelectAll(value) {
    this.isRegionAll = true
  }

  onRegionDeSelectAll(value) {
    this.isRegionAll = false
  }

  /**
   * @author Nagendra
   * @description On select/deselect item from dropdowns
   * @date 24-10-2018
   * @modified date 24-10-2018
   */
  onCountrySelect(value) {
    this.isCountryAll = false
  }

  onCountryDeSelect(value) {
    this.isCountryAll = false
  }

  onSalesTypeSelect(value) {
    this.isSalesTypeAll = false
  }

  onSalesTypeDeSelect(value) {
    this.isSalesTypeAll = false
  }

  onOwnershipStatusSelect(value) {
    this.isOwnershipStatusAll = false
  }

  onOwnershipStatusDeSelect(value) {
    this.isOwnershipStatusAll = false
  }

  onDealerListSelect(value) {
    this.isDealerListAll = false
  }

  onDealerListDeSelect(value) {
    this.isDealerListAll = false
  }

  onRegionSelect(value) {
    this.isRegionAll = false
  }

  onRegionDeSelect(value) {
    this.isRegionAll = false
  }

  /**
   * @author Nagendra
   * @description Used to clear criteria in advance search and make selected values to empty
   * @created Date 25-10-2018
   * @modified Date 26-10-2018
   */
  clearCriteria() {
    this.advanceOwnerSearchfields = new OwnersAdvanceSearch("", [], null, [], [], "", [], null, null, 0, 10, true, "", "", "", [], false);
    this.salesTypeSelected = [];
    this.countrySelected = [];
    this.ownershipStatusSelected = [];
    this.dealerListSelected = [];
    this.ownerExportStatus = true;

    this.p = 1;
  }

  /**
   * @author Nagendra
   * @description After criteria defined each value will be given with delete option from adv search
   * @created Date 25-10-2018
   * @modified Date 29-10-2018
   */
  removeFromCriteria(i) {

    const criteriaIndex = i;
    const criteriaLabel = this.showCriteria[i]['label'];
    const criteriaValue = this.showCriteria[i]['id'];

    this.showCriteria.forEach(obj => {
      if (obj.label == "Relative Purchase Date" && criteriaLabel == "Relative Purchase Date") {
        this.RDSelected = "";
        this.advanceOwnerSearchfields.fromPurchaseDate = ""
        this.advanceOwnerSearchfields.toPruchaseDate = ""
        this.advanceSearch();
      }
      if (obj.label == "LastName" && criteriaLabel == "LastName") {
        this.lastName = "";
        this.advanceSearch();
      }
      if (obj.label == "firstName" && criteriaLabel == "firstName") {
        this.advanceOwnerSearchfields.firstName = "";
        this.advanceSearch();
      }
      if (obj.label == "VIN" && criteriaLabel == "VIN") {
        this.advanceOwnerSearchfields.vin = "";
        this.advanceSearch();
      }
      if (obj.label == "Purchase Date" && criteriaLabel == "Purchase Date") {
        this.advanceOwnerSearchfields.fromPurchaseDate = "";
        this.fromPurchaseDate = null;
        this.advanceSearch();
      }
      if (obj.label == "From Date" && criteriaLabel == "From Date") {
        this.advanceOwnerSearchfields.fromPurchaseDate = "";
        this.fromPurchaseDate = null;
        this.advanceSearch();
      }
      if (obj.label == "To Date" && criteriaLabel == "To Date") {
        this.advanceOwnerSearchfields.toPruchaseDate = "";
        this.toPurchaseDate = null;
        this.advanceSearch();
      }


      if (obj.label == "Country Code" && criteriaLabel == "Country Code") {
        this.countrySelected.forEach((obj, index) => {
          if (this.countrySelected[index]['id'] == criteriaValue) {
            this.countrySelected.splice(index, 1);
          }
        });
        //To remove Country code All
        if (obj.id == 'countryCodeAll' && this.showCriteria[criteriaIndex]['id'] == 'countryCodeAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isCountryAll = false;
          this.countrySelected = [];
        }
        if (criteriaValue == 'maxCountry') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.countrySelected = []
        }
        this.advanceSearch();
      }

      if (obj.label == "Region" && criteriaLabel == "Region") {
        this.regionSelected.forEach((obj, index) => {
          if (this.regionSelected[index]['id'] == criteriaValue) {
            this.regionSelected.splice(index, 1);
          }
        });
        //To remove Country code All
        if (obj.id == 'regionAll' && this.showCriteria[criteriaIndex]['id'] == 'regionAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isRegionAll = false;
          this.regionSelected = [];
        }
        if (criteriaValue == 'maxRegion') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.regionSelected = []
        }
        this.advanceSearch();
      }
      if (obj.label == "Sale Type" && criteriaLabel == "Sale Type") {
        this.salesTypeSelected.forEach((obj, index) => {
          if (this.salesTypeSelected[index]['id'] == criteriaValue) {
            this.salesTypeSelected.splice(index, 1);
          }
        });
        //To remove sales Type All
        if (obj.id == 'saleTypeAll' && this.showCriteria[criteriaIndex]['id'] == 'saleTypeAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isSalesTypeAll = false;
          this.salesTypeSelected = [];
        }
        if (criteriaValue == 'maxSaleType') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.salesTypeSelected = []
        }
        this.advanceSearch();
      }
      if (obj.label == "Ownership Status" && criteriaLabel == "Ownership Status") {
        this.ownershipStatusSelected.forEach((obj, index) => {
          if (this.ownershipStatusSelected[index]['id'] == criteriaValue) {
            this.ownershipStatusSelected.splice(index, 1);
          }
        });
        //To remove OwnershipCycle All
        if (obj.id == 'ownershipStatusAll' && this.showCriteria[criteriaIndex]['id'] == 'ownershipStatusAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isOwnershipStatusAll = false;
          this.ownershipStatusSelected = [];
        }
        if (criteriaValue == 'maxOwnershipStatus') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.ownershipStatusSelected = []
        }
        this.advanceSearch();
      }
      if (obj.label == "Dealer Name" && criteriaLabel == "Dealer Name") {
        this.dealerListSelected.forEach((obj, index) => {
          if (this.dealerListSelected[index]['id'] == criteriaValue) {
            this.dealerListSelected.splice(index, 1);
          }
        });
        //To remove DealerName All
        if (obj.id == 'dealerNameAll' && this.showCriteria[criteriaIndex]['id'] == 'dealerNameAll') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.isDealerListAll = false;
          this.dealerListSelected = [];
        }
        if (criteriaValue == 'maxDealer') {
          this.showCriteria.splice(criteriaIndex, 1);
          this.dealerListSelected = []
        }
        this.advanceSearch();
      }
    });
    if (Object.keys(this.showCriteria).length == 0) {
      this.showadvanceSearch(false)
    }
  }

  /**
   * @author Nagendra
   * To handle date on selection and sending
   */
  onSelectFromPurchase(event) {
    let d = new Date(Date.parse(event));
    this.advanceOwnerSearchfields.fromPurchaseDate = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  }

  onSelectToPurchase(event) {
    let d = new Date(Date.parse(event));
    this.advanceOwnerSearchfields.toPruchaseDate = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  }

  /**
   * @author Jayasimha
   * @description Export Leads using different criteria
   * @created Date 30-01-2019
   */
  exportOwnersList() {
    let newHeader = [];
    let newOwners;
    let column;
    this.finalExportData = [];
    this.headerOwnersList.forEach(prefprop => {
      newHeader.push(prefprop.setting.label);
    });
    this.advanceOwnerSearchfields.isPagination = false;
    if (this.normalSearch == true) {
      this._ownerService.getOwnerSearch(this.userId, this.lastName, 1, 1, this.column, this.sort, (result) => {
        result.beans.forEach(eachObj => {
          newOwners = {};
          this.headerOwnersList.forEach(prefprop => {
            column = prefprop.setting.property.slice(6);
            if (eachObj[column] != "" || eachObj[column] != null) {
              if (column == "submissionDate" || column == "dateEntered") {
                eachObj[column] = moment(eachObj[column]).format("MM/DD/YYYY HH:mm:ss");
              } else if (column == "optedIn") {
                eachObj[column] = eachObj[column] ? 'Yes' : 'No';
              }
              newOwners[prefprop.setting.label] = eachObj[column];

            } else {
              newOwners[prefprop.setting.label] = null;
            }
          });
          this.finalExportData.push(newOwners);
        });
        var today: string = moment().format('D MMM YYYY HH:mm:ss');
        var options = {
          showLabels: true,
          headers: newHeader
        };
        new Angular2Csv(this.finalExportData, 'My_Report' + today, options);
      });
    } else if (this.advanceSearchList == true) {
      this._ownerService.getSearchOwnerList(this.advanceOwnerSearchfields, (result) => {
        result.beans.forEach(eachObj => {
          newOwners = {};
          this.headerOwnersList.forEach(prefprop => {
            column = prefprop.setting.property.slice(6);
            if (eachObj[column] != "" || eachObj[column] != null) {
              if (column == "submissionDate" || column == "dateEntered") {
                eachObj[column] = moment(eachObj[column]).format("MM/DD/YYYY HH:mm:ss");
              } else if (column == "optedIn") {
                eachObj[column] = eachObj[column] ? 'Yes' : 'No';
              }
              newOwners[prefprop.setting.label] = eachObj[column];

            } else {
              newOwners[prefprop.setting.label] = null;
            }
          });
          this.finalExportData.push(newOwners);
        });
        var today: string = moment().format('D MMM YYYY HH:mm:ss');
        var options = {
          showLabels: true,
          headers: newHeader
        };
        new Angular2Csv(this.finalExportData, 'My_Report' + today, options);
      });

    } else {
      this._ownerService.getOwnersList(this.userId, this.offset, 100000, this.column, this.sort, (result) => {
        result.beans.forEach(eachObj => {
          newOwners = {};
          this.headerOwnersList.forEach(prefprop => {
            column = prefprop.setting.property.slice(6);
            if (eachObj[column] != "" || eachObj[column] != null) {
              if (column == "submissionDate" || column == "dateEntered") {
                eachObj[column] = moment(eachObj[column]).format("MM/DD/YYYY HH:mm:ss");
              } else if (column == "optedIn") {
                eachObj[column] = eachObj[column] ? 'Yes' : 'No';
              }
              newOwners[prefprop.setting.label] = eachObj[column];

            } else {
              newOwners[prefprop.setting.label] = null;
            }
          });
          this.finalExportData.push(newOwners);
        });
        var today: string = moment().format('D MMM YYYY HH:mm:ss');
        var options = {
          showLabels: true,
          headers: newHeader
        };
        new Angular2Csv(this.finalExportData, 'My_Report' + today, options);
      })


    }
  }

  getRegionList() {
    this._ownerService.getRegionList((result) => {
      this.regionList = result

    })
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/owners/components/owner.component.ts